/**
 * Apply the tab in the same tap as the highlight. A deferred swap paints the
 * selection, then paints it again when the form and URL catch up.
 *
 * @param {string} type
 * @param {string} current
 * @param {(type: string) => void} onChange
 * @returns {boolean} true when the tab changed
 */
const TAB_CHANGE_GUARD_MS = 500;
let lastHomepageTabChangeAt = 0;

export function queueHomepageTabChange(type, current, onChange, now = Date.now()) {
  if (typeof onChange !== 'function' || !type || type === current) {
    return false;
  }
  // A layout shift after the tap can deliver a second click on another tab.
  if (
    lastHomepageTabChangeAt > 0
    && now >= lastHomepageTabChangeAt
    && now - lastHomepageTabChangeAt < TAB_CHANGE_GUARD_MS
  ) {
    return false;
  }
  lastHomepageTabChangeAt = now;
  onChange(type);
  return true;
}

/**
 * /flights, /hotels, and /trains name the tab. A saved value is only for other routes.
 * @param {string} pathname
 * @returns {'flight' | 'hotel' | 'train' | null}
 */
export function formTypeFromHomepagePath(pathname) {
  if (pathname === '/flights') return 'flight';
  if (pathname === '/hotels') return 'hotel';
  if (pathname === '/trains') return 'train';
  return null;
}

/**
 * Once the URL names a tab, that tab stays. A leftover tap must not paint a different one.
 * @param {string | null} pathFormType
 * @param {string | null} requestedFormType
 * @returns {string | null}
 */
export function formTypeAfterHomepageNavigation(pathFormType, requestedFormType) {
  if (pathFormType) return pathFormType;
  return requestedFormType || null;
}

/**
 * Saved tab sync is ignored on /flights, /hotels, and /trains so another tab cannot flip this page.
 * @param {string | null} pathFormType
 * @param {string | null | undefined} storedFormType
 * @returns {string | null}
 */
export function homepageFormTypeFromStorage(pathFormType, storedFormType) {
  if (pathFormType) return null;
  return storedFormType || null;
}

/**
 * @param {string | null | undefined} pressedTab
 * @param {string} activeFormType
 * @returns {string}
 */
export function shownHomepageTab(pressedTab, activeFormType) {
  return pressedTab || activeFormType;
}
